import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import mapImg from '../../assets/images/map.jpg';
import { colorsPalette, LARGE_MARGIN, MIDDLE_MARGIN, BIG_MARGIN, SMALL_MARGIN } from '../../theme';

const useStyles = (background) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        paddingTop: MIDDLE_MARGIN,
        paddingBottom: 0,
        background: theme.palette.secondary.dark,
        overflowX: 'hidden',
        position: 'relative',
        '&:first-child': {
          paddingTop: 260,
        },
        [theme.breakpoints.up('sm')]: {
          background:
            background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,
        },
        [theme.breakpoints.up('md')]: {
          paddingTop: LARGE_MARGIN,
          paddingBottom: LARGE_MARGIN,
          '&:first-child': {
            paddingTop: 190,
            paddingBottom: 150,
          },
        },
      },
      container: {
        display: 'flex',
        justifyContent: 'flex-end',
      },
      bgImageWrapper: {
        position: 'absolute',
        top: '0',
        left: '50%',
        transform: 'translate(-50%, 0%)',
        width: '100%',
        maxHeight: 500,
        height: '100%',
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: 540,
          background: 'linear-gradient(0deg, #1B1925 12.5%, rgba(27, 25, 37, 0.0001) 100%);',
          zIndex: 1,
        },
        [theme.breakpoints.up('md')]: {
          maxHeight: 'unset',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background:
              'linear-gradient(90deg, rgba(27, 25, 37, 0.720783) 0%, rgba(27, 25, 37, 0.0001) 100%)',
            zIndex: 1,
          },
        },
      },
      bgImage: {
        position: 'absolute',
        height: '100%',
        top: 0,
        left: '50%',
        transform: 'translateX(-35%)',
        [theme.breakpoints.up('sm')]: {
          transform: 'translateX(-50%)',
        },
        [theme.breakpoints.up('md')]: {
          transform: 'translateX(-42%)',
        },
        [theme.breakpoints.up('lg')]: {
          transform: 'translateX(-50%)',
        },
      },
      content: {
        width: '100%',
        maxWidth: 720,
        position: 'relative',
        padding: `${MIDDLE_MARGIN}px ${SMALL_MARGIN}px`,
        background: colorsPalette.blackSecondary,
        borderRadius: 5,
        boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.4)',
        zIndex: 2,
        [theme.breakpoints.up('md')]: {
          padding: `${BIG_MARGIN}px ${MIDDLE_MARGIN}px`,
          maxWidth: 500,
        },
        [theme.breakpoints.up('lg')]: {
          maxWidth: 720,
        },
      },
      heading: {
        marginBottom: 8,
      },
      subtitle: {
        marginBottom: MIDDLE_MARGIN,
      },
    }),
  );

export const useContactFormStyles = makeStyles((theme: Theme) =>
  createStyles({
    contactForm: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      [theme.breakpoints.up('sm')]: {
        alignItems: 'flex-start',
      },
    },
    contactFormFieldWrap: {
      marginBottom: SMALL_MARGIN,
      width: '100%',
    },
    contactFormField: {
      width: '100%',
    },
    errorMsg: {
      display: 'block',
      marginTop: 6,
      paddingLeft: 8,
      color: colorsPalette.red,
    },
    contactFormButton: {
      marginTop: 36,
    },
    contactMap: {
      display: 'block',
      width: '100%',
      height: 258,
      borderRadius: 5,
      overflow: 'hidden',
      background: `url(${mapImg})`,
      backgroundSize: 'cover',
      marginBottom: 35,
      [theme.breakpoints.up('sm')]: {
        width: 'calc(50% - 15px)',
        height: 448,
        marginBottom: 0,
        backgroundPositionY: '-1px',
      },
    },
    menu: {},
    popover: {
      fontSize: 16,
      width: 300,
      marginLeft: 15,
      color: colorsPalette.gray,
      background: theme.palette.secondary.light,

      [theme.breakpoints.up('sm')]: {
        width: 500,
      },
    },
  }),
);

export default useStyles;
